import axios from 'axios'
import 'nprogress/nprogress.css'
import NProgress from 'nprogress'


const ajax = axios.create({
	baseURL:'/front', //请求基本路径
	// timeout:10000, //超时时间
})

//请求拦截器
ajax.interceptors.request.use((config)=>{
	NProgress.start() 
	return config
})

//响应拦截器
ajax.interceptors.response.use(
	(response)=>{
		NProgress.done() 
		return response.data 
	},
	()=>{
		// alert(error) 
		NProgress.done() 
		return new Promise(()=>{})
	}
)

export default ajax


